// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/auth/v1/displayagent.proto (package chalk.auth.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { FeaturePermissions } from "./featurepermission_pb";
import { file_chalk_auth_v1_featurepermission } from "./featurepermission_pb";
import type { Permission } from "./permissions_pb";
import { file_chalk_auth_v1_permissions } from "./permissions_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/auth/v1/displayagent.proto.
 */
export const file_chalk_auth_v1_displayagent: GenFile = /*@__PURE__*/
  fileDesc("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", [file_chalk_auth_v1_featurepermission, file_chalk_auth_v1_permissions, file_google_protobuf_timestamp]);

/**
 * @generated from message chalk.auth.v1.DisplayPermission
 */
export type DisplayPermission = Message<"chalk.auth.v1.DisplayPermission"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: chalk.auth.v1.Permission permission = 2;
   */
  permission: Permission;
};

/**
 * Describes the message chalk.auth.v1.DisplayPermission.
 * Use `create(DisplayPermissionSchema)` to create a new message.
 */
export const DisplayPermissionSchema: GenMessage<DisplayPermission> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_displayagent, 0);

/**
 * @generated from message chalk.auth.v1.DisplayEnvironmentPermissions
 */
export type DisplayEnvironmentPermissions = Message<"chalk.auth.v1.DisplayEnvironmentPermissions"> & {
  /**
   * @generated from field: string environment_id = 1;
   */
  environmentId: string;

  /**
   * @generated from field: string environment_name = 2;
   */
  environmentName: string;

  /**
   * @generated from field: string project_id = 3;
   */
  projectId: string;

  /**
   * @generated from field: string project_name = 4;
   */
  projectName: string;

  /**
   * @generated from field: repeated chalk.auth.v1.DisplayPermission permissions = 5;
   */
  permissions: DisplayPermission[];
};

/**
 * Describes the message chalk.auth.v1.DisplayEnvironmentPermissions.
 * Use `create(DisplayEnvironmentPermissionsSchema)` to create a new message.
 */
export const DisplayEnvironmentPermissionsSchema: GenMessage<DisplayEnvironmentPermissions> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_displayagent, 1);

/**
 * @generated from message chalk.auth.v1.DisplayUserAgent
 */
export type DisplayUserAgent = Message<"chalk.auth.v1.DisplayUserAgent"> & {
  /**
   * @generated from field: string client_id = 1 [deprecated = true];
   * @deprecated
   */
  clientId: string;

  /**
   * @generated from field: string user_id = 2;
   */
  userId: string;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;

  /**
   * @generated from field: repeated chalk.auth.v1.DisplayEnvironmentPermissions permissions_by_environment = 4;
   */
  permissionsByEnvironment: DisplayEnvironmentPermissions[];

  /**
   * @generated from field: bool impersonated = 5;
   */
  impersonated: boolean;

  /**
   * @generated from field: string name = 6;
   */
  name: string;

  /**
   * @generated from field: string email = 7;
   */
  email: string;

  /**
   * @generated from field: string team_name = 8;
   */
  teamName: string;

  /**
   * @generated from field: repeated chalk.auth.v1.DisplayCustomClaim customer_claims = 9;
   */
  customerClaims: DisplayCustomClaim[];
};

/**
 * Describes the message chalk.auth.v1.DisplayUserAgent.
 * Use `create(DisplayUserAgentSchema)` to create a new message.
 */
export const DisplayUserAgentSchema: GenMessage<DisplayUserAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_displayagent, 2);

/**
 * @generated from message chalk.auth.v1.DisplayCustomClaim
 */
export type DisplayCustomClaim = Message<"chalk.auth.v1.DisplayCustomClaim"> & {
  /**
   * @generated from field: string key = 1;
   */
  key: string;

  /**
   * @generated from field: repeated string values = 2;
   */
  values: string[];
};

/**
 * Describes the message chalk.auth.v1.DisplayCustomClaim.
 * Use `create(DisplayCustomClaimSchema)` to create a new message.
 */
export const DisplayCustomClaimSchema: GenMessage<DisplayCustomClaim> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_displayagent, 3);

/**
 * @generated from message chalk.auth.v1.DisplayServiceTokenAgent
 */
export type DisplayServiceTokenAgent = Message<"chalk.auth.v1.DisplayServiceTokenAgent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string client_id = 2;
   */
  clientId: string;

  /**
   * @generated from field: string team_id = 3;
   */
  teamId: string;

  /**
   * @generated from field: string project_id = 4;
   */
  projectId: string;

  /**
   * @generated from field: string environment_id = 5;
   */
  environmentId: string;

  /**
   * @generated from field: repeated chalk.auth.v1.DisplayPermission permissions = 6;
   */
  permissions: DisplayPermission[];

  /**
   * @generated from field: string name = 7;
   */
  name: string;

  /**
   * @generated from field: string team_name = 8;
   */
  teamName: string;

  /**
   * @generated from field: string project_name = 9;
   */
  projectName: string;

  /**
   * @generated from field: string environment_name = 10;
   */
  environmentName: string;

  /**
   * @generated from field: repeated chalk.auth.v1.DisplayCustomClaim customer_claims = 11;
   */
  customerClaims: DisplayCustomClaim[];

  /**
   * @generated from field: chalk.auth.v1.FeaturePermissions feature_permissions = 12;
   */
  featurePermissions?: FeaturePermissions;

  /**
   * @generated from field: google.protobuf.Timestamp created_at = 13;
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: repeated chalk.auth.v1.DisplayPermission team_permissions = 14;
   */
  teamPermissions: DisplayPermission[];
};

/**
 * Describes the message chalk.auth.v1.DisplayServiceTokenAgent.
 * Use `create(DisplayServiceTokenAgentSchema)` to create a new message.
 */
export const DisplayServiceTokenAgentSchema: GenMessage<DisplayServiceTokenAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_displayagent, 4);

/**
 * @generated from message chalk.auth.v1.DisplayEngineAgent
 */
export type DisplayEngineAgent = Message<"chalk.auth.v1.DisplayEngineAgent"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string team_id = 2;
   */
  teamId: string;

  /**
   * @generated from field: string project_id = 3;
   */
  projectId: string;

  /**
   * @generated from field: string environment_id = 4;
   */
  environmentId: string;

  /**
   * @generated from field: bool impersonated = 5;
   */
  impersonated: boolean;

  /**
   * @generated from field: string team_name = 6;
   */
  teamName: string;

  /**
   * @generated from field: string project_name = 7;
   */
  projectName: string;

  /**
   * @generated from field: string environment_name = 8;
   */
  environmentName: string;
};

/**
 * Describes the message chalk.auth.v1.DisplayEngineAgent.
 * Use `create(DisplayEngineAgentSchema)` to create a new message.
 */
export const DisplayEngineAgentSchema: GenMessage<DisplayEngineAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_displayagent, 5);

/**
 * @generated from message chalk.auth.v1.DisplayTenantAgent
 */
export type DisplayTenantAgent = Message<"chalk.auth.v1.DisplayTenantAgent"> & {
};

/**
 * Describes the message chalk.auth.v1.DisplayTenantAgent.
 * Use `create(DisplayTenantAgentSchema)` to create a new message.
 */
export const DisplayTenantAgentSchema: GenMessage<DisplayTenantAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_displayagent, 6);

/**
 * @generated from message chalk.auth.v1.DisplayMetadataServiceAgent
 */
export type DisplayMetadataServiceAgent = Message<"chalk.auth.v1.DisplayMetadataServiceAgent"> & {
};

/**
 * Describes the message chalk.auth.v1.DisplayMetadataServiceAgent.
 * Use `create(DisplayMetadataServiceAgentSchema)` to create a new message.
 */
export const DisplayMetadataServiceAgentSchema: GenMessage<DisplayMetadataServiceAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_displayagent, 7);

/**
 * @generated from message chalk.auth.v1.DisplayAgent
 */
export type DisplayAgent = Message<"chalk.auth.v1.DisplayAgent"> & {
  /**
   * @generated from oneof chalk.auth.v1.DisplayAgent.agent
   */
  agent: {
    /**
     * @generated from field: chalk.auth.v1.DisplayUserAgent user_agent = 1;
     */
    value: DisplayUserAgent;
    case: "userAgent";
  } | {
    /**
     * @generated from field: chalk.auth.v1.DisplayServiceTokenAgent service_token_agent = 2;
     */
    value: DisplayServiceTokenAgent;
    case: "serviceTokenAgent";
  } | {
    /**
     * @generated from field: chalk.auth.v1.DisplayEngineAgent engine_agent = 3;
     */
    value: DisplayEngineAgent;
    case: "engineAgent";
  } | {
    /**
     * @generated from field: chalk.auth.v1.DisplayTenantAgent tenant_agent = 4;
     */
    value: DisplayTenantAgent;
    case: "tenantAgent";
  } | {
    /**
     * @generated from field: chalk.auth.v1.DisplayMetadataServiceAgent metadata_service_agent = 5;
     */
    value: DisplayMetadataServiceAgent;
    case: "metadataServiceAgent";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.auth.v1.DisplayAgent.
 * Use `create(DisplayAgentSchema)` to create a new message.
 */
export const DisplayAgentSchema: GenMessage<DisplayAgent> = /*@__PURE__*/
  messageDesc(file_chalk_auth_v1_displayagent, 8);

